export const externalLinkProps = {
  rel: 'no-referrer',
  target: '_blank',
};
